import { AggregationType } from "types/charts";

export enum CampaignMetrics {
  TOTAL_ENGAGEMENT = "totalEngagement",
  ENGAGED_MEMBERS = "engagedMembers",
}

export type CampaignMetricsUnion = `${CampaignMetrics}`;

type CampaignDataHeader = {
  [Property in CampaignMetricsUnion]: number;
};

export type CampaignAnalyticsData = {
  aggregationType: AggregationType;
  intervalStartDate: string;
  intervalEndDate: string;
  dataType: CampaignMetricsUnion;
  header: CampaignDataHeader;
  data: {
    [key: string]: number;
  };
  comparativePeriodData: {
    [key: string]: number;
  };
};
